import React from "react";
import PropTypes from "prop-types";

const CheckBox = ({ id, checked, onChange, titleClassName, title, tabIndex }) => {
    return (<div className="checkbox checkbox-primary">
        <label id={id + 'ToClick'}>
            <input id={id}
                checked={checked}
                onChange={onChange}
                tabIndex={tabIndex}
                type="checkbox" />
            <span className="checkbox-material">
                <span className="check" />
            </span>
            <div style={{ paddingLeft: "10px", verticalAlign: "middle" }}
                className={titleClassName ? titleClassName : ""}>
                <span>{title}</span>
            </div>
        </label>
    </div>);
};

CheckBox.defaultProps = {
    tabIndex: -1
};

CheckBox.propTypes = {
    id: PropTypes.any,
    checked:PropTypes.bool,
    titleClassName: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    title: PropTypes.string,
    tabIndex: PropTypes.number
};

export default CheckBox;
